import { Box, IconButton, Switch, Tooltip, } from '@mui/material';
import PropTypes from 'prop-types';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Booking } from '../models';
import { COLOR_CODE, I18N, ROLES } from 'src/shared/constants/constants';
import { useSelector, useDispatch } from 'react-redux';
import { FC, useState, useEffect } from 'react';
import { selectUserState } from 'src/auth/login/services/userSlice';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

interface UserManagementTableProps {
  className?: string;
  inputLoginUserRole: string;
  handleViewIconClick(row: any): void;
  handleEditIconClick(row: any): void;
  handleDeleteIconClick(row: any): void;
  handleSwitchIconClick(email: any): void;
  inputBookingData: Booking[];
}

const BookinManagementTable: FC<UserManagementTableProps> = ({
  handleEditIconClick,
  handleViewIconClick,
  handleDeleteIconClick,
  handleSwitchIconClick,
  inputLoginUserRole,
  inputBookingData
}) => {
  const { userData } = useSelector(selectUserState);
  const [userTableColumns, setuserTableColumns] = useState([]);
  const handleEditIconClickEvent = (row) => {
    handleEditIconClick(row);
  };

  const handleSwitchIconClickEvent = (row) => {
    handleSwitchIconClick(row);
  };

  const handleDeleteIconClickEvent = (row) => {
    handleDeleteIconClick(row);
  };
  const navigate = useNavigate();

  const { t } = useTranslation(I18N.DEFAULT);
  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'name',
      headerName: t('name'),
      sortable: false,
      flex: 1,
    },
    {
      field: 'billNo',
      headerName: t('booking.billNo'),
      filterable: false,
      flex: 1
    },
    {
      field: 'mobile',
      headerName: t('booking.mobile'),
      filterable: false,
      flex: 1
    },
    {
      field: 'deliveryDate',
      headerName: t('booking.deliverydate'),
      filterable: false,
      flex: 1,
      valueGetter: (params) => {
        if (params?.row?.deliveryDate) {
          const date: Date = new Date(params?.row?.deliveryDate);
          return `${date.toLocaleString('en-GB', { hour12: true }) || ''}`;
        }
        return '';
      }
    }, 
    {
      field: 'returnDate',
      headerName: t('booking.returndate'),
      filterable: false,
      flex: 1,
      valueGetter: (params) => {
        if (params?.row?.returnDate) {
          const date: Date = new Date(params?.row?.returnDate);
          return `${date.toLocaleString('en-GB', { hour12: true }) || ''}`;
        }
        return '';
      }
    },

    {
      field: 'bookingStatus',
      headerName: t('booking.bookingstatus'),
      sortable: true,
      flex: 1
      // valueGetter: (params) => {
      //   return `${params.row.role.roleName || ''}`;
      // }
    }
  ];
  const getRowClassName = (params: GridRenderCellParams<any>) => {
    return params?.row?.colorCode ? `table-back-gound-${params.row.colorCode}` : `table-back-gound-${COLOR_CODE.DEFAULT}`;
  };
  const actionColumn: GridColDef = {
    field: t('actions'),
    sortable: false,
    flex: 1,
    renderCell: (params: GridRenderCellParams<any>) => {
      return (
        <>
          {/* <Tooltip title={t('delete')} arrow>
            <IconButton
              color="inherit"
              size="small"
              className="RecentOrderDeleteButton"
              onClick={() => handleDeleteIconClickEvent(params.row)}
            >
              <DeleteTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          {/* <Tooltip title={t('edit')} arrow>
            <IconButton
              aria-label="editUser"
              onClick={() => handleEditIconClickEvent(params.row)}
              className="RecentOrderEditButton ml-8"
              color="inherit"
              size="small"
            >
              <EditTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title={t('view')} arrow>
            <IconButton
              aria-label="editUser"
              onClick={() => handleViewIconClick(params.row)}
              className="RecentOrderEditButton ml-8"
              color="inherit"
              size="small"
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      );
    }
  };
  useEffect(() => {
    if (inputLoginUserRole === ROLES.TENANT_OPERATOR) {
      setuserTableColumns(columns);
    } else {
      setuserTableColumns([...columns, actionColumn]);
    }
  }, []);
  return (
    <>
      <Card className="mb-24">
        <Tables
          rows={inputBookingData}
          getRowClassName={getRowClassName}
          columns={userTableColumns}
          checkboxSelection={false}
        />
      </Card>
    </>
  );
};

BookinManagementTable.propTypes = {
  inputBookingData: PropTypes.array.isRequired
};

BookinManagementTable.defaultProps = {
  inputBookingData: []
};

export default BookinManagementTable;
